/* eslint-disable */
import axiosIns from '@/libs/axios'
import { requestApi } from '@/libs/secret'

export default {
  namespaced: true,
  state: {
    dataBidding: {
      items: {},
      fields: [
        { key: 'hour_formatted', label: 'Hour', sortable: false },
        { key: 'impression', label: 'Impression', sortable: true },
        { key: 'click', label: 'Click', sortable: true },
        { key: 'sales', label: 'Sales', sortable: true },
        { key: 'bid_status', label: '' },
      ],
      status: [
        {
          1: 'Active', 2: 'Win', 3: 'Closed',
        },
        {
          1: 'success', 2: 'warning', 3: 'secondary',
        },
      ],
    },
    channelSelected: 1,
    methodSelected: 1,
    dataSend: {
      campaign_id: null,
      hour: 0,
      bid_percentage: 1,
    },
    dataRunningCampaign: {
      items: {
        total: 6,
        per_page: 6,
        current_page: 1,
        from: 1,
        to: 6,
        data: [],
      },
      fields: [
        { key: 'campaign_id', label: 'Campaign ID', sortable: true },
        { key: 'campaign_name', label: 'Campaign Name', sortable: true },
        { key: 'company_name', label: 'Company Name', sortable: true },
        { key: 'channel_name', label: 'Channel', sortable: true },
        { key: 'method_name', label: 'Buy Method', sortable: true },
        { key: 'sent', label: 'Sent', sortable: true, thClass: 'd-none', tdClass: 'd-none'},
        { key: 'impression', label: 'Impressions', sortable: true },
        { key: 'click', label: 'Clicks' },
        { key: 'ctr', label: 'CTR', sortable: true },
        { key: 'cvr', label: 'CVR', sortable: true },
        { key: 'mt', label: 'Sales', sortable: true },
        { key: 'total_usage', label: 'Cost', sortable: true },
        { key: 'action', label: '' },
      ],
      status: [
        {
          1: 'Waiting Approval', 2: 'Approved', 3: 'Rejected',
        },
        {
          1: 'light-warning', 2: 'light-success', 3: 'light-danger',
        },
      ],
      sortBy: '',
      sortDesc: false,
      search: '',
    },
    // dataAuction: {
    //   items: {},
    //   fields: [
    //     { key: 'checkbox', label: '', sortable: false },
    //     { key: 'channel', label: 'Channel', sortable: true },
    //     { key: 'volume', label: 'Volume', sortable: true },
    //     { key: 'day', label: 'Day', sortable: true },
    //     { key: 'hour', label: 'Hour', sortable: true },
    //     { key: 'comments', label: 'Comments', sortable: true },
    //     { key: 'finish_time', label: 'Finish Time', sortable: true },
    //     { key: 'winning_bid', label: 'Winning Bid', sortable: true },
    //     { key: 'status', label: 'Status' },
    //     { key: 'actions', label: '' },
    //   ],
    //   status: [
    //     {
    //       1: 'Active', 2: 'Win', 3: 'Closed',
    //     },
    //     {
    //       1: 'success', 2: 'warning', 3: 'secondary',
    //     },
    //   ],
    // },
    // dataWon: {
    //   items: {},
    //   fields: [
    //     { key: 'checkbox', label: '', sortable: false },
    //     { key: 'channel', label: 'Channel', sortable: true },
    //     { key: 'volume', label: 'Volume', sortable: true },
    //     { key: 'day', label: 'Day', sortable: true },
    //     { key: 'hour', label: 'Hour', sortable: true },
    //     { key: 'comments', label: 'Comments', sortable: true },
    //     { key: 'finish_time', label: 'Finish Time', sortable: true },
    //     { key: 'winning_bid', label: 'Winning Bid', sortable: true },
    //     { key: 'status', label: 'Status' },
    //     { key: 'actions', label: '' },
    //   ],
    //   status: [
    //     {
    //       1: 'Active', 2: 'Win', 3: 'Closed',
    //     },
    //     {
    //       1: 'success', 2: 'warning', 3: 'secondary',
    //     },
    //   ],
    // },
    // dataClose: {
    //   items: {},
    //   fields: [
    //     { key: 'checkbox', label: '', sortable: false },
    //     { key: 'channel', label: 'Channel', sortable: true },
    //     { key: 'volume', label: 'Volume', sortable: true },
    //     { key: 'day', label: 'Day', sortable: true },
    //     { key: 'hour', label: 'Hour', sortable: true },
    //     { key: 'comments', label: 'Comments', sortable: true },
    //     { key: 'finish_time', label: 'Finish Time', sortable: true },
    //     { key: 'winning_bid', label: 'Winning Bid', sortable: true },
    //     { key: 'status', label: 'Status' },
    //     // { key: 'actions', label: '' },
    //   ],
    //   status: [
    //     {
    //       1: 'Active', 2: 'Win', 3: 'Closed',
    //     },
    //     {
    //       1: 'success', 2: 'warning', 3: 'secondary',
    //     },
    //   ],
    // },
  },
  getters: {
    getBiddingItem: state => state.dataBidding.items,
    getBiddingField: state => state.dataBidding.fields,
    getBiddingStatus: state => state.dataBidding.status,
    getBiddingCurrentPage: state => state.dataBidding.items.current_page,
    
    getRunningItem: state => state.dataRunningCampaign.items,
    getRunningField: state => state.dataRunningCampaign.fields,
    getRunningStatus: state => state.dataRunningCampaign.status,
    
    getDataSend: state => state.dataSend,
    getChannel: state => state.channelSelected,
    getMethod: state => state.methodSelected,
    // getAuctionItem: state => state.dataAuction.items,
    // getAuctionField: state => state.dataAuction.fields,
    // getAuctionStatus: state => state.dataAuction.status,
    // getWonItem: state => state.dataWon.items,
    // getWonField: state => state.dataWon.fields,
    // getWonStatus: state => state.dataWon.status,
    // getCloseItem: state => state.dataClose.items,
    // getCloseField: state => state.dataClose.fields,
    // getCloseStatus: state => state.dataClose.status,
  },
  mutations: {
    SET_ITEM_DATA_BID: (state, value) => (value ? (state.dataBidding.items = value) : (state.dataBidding.items = {})),
    SET_BIDDING_CURRENT_PAGE: (state, value) => (value ? (state.dataBidding.items.current_page = value) : (state.dataBidding.items.current_page = 1)),
    SET_BIDDING_SORT_BY: (state, value) => (value ? (state.dataBidding.items.sortBy = value) : (state.dataBidding.items.sortBy = '')),
    SET_BIDDING_SORT_DESC: (state, value) => (value ? (state.dataBidding.items.sortDesc = value) : (state.dataBidding.items.sortDesc = false)),
    SET_BIDDING_SEARCH: (state, value) => (value ? (state.dataBidding.items.search = value) : (state.dataBidding.items.search = '')),

    SET_ITEM_DATA_RUN: (state, value) => (value ? (state.dataRunningCampaign.items = value) : (state.dataRunningCampaign.items = {})),
    SET_RUNNING_CURRENT_PAGE: (state, value) => (value ? (state.dataRunningCampaign.items.current_page = value) : (state.dataRunningCampaign.items.current_page = 1)),
    SET_RUNNING_SORT_BY: (state, value) => (value ? (state.dataRunningCampaign.items.sortBy = value) : (state.dataRunningCampaign.items.sortBy = '')),
    SET_RUNNING_SORT_DESC: (state, value) => (value ? (state.dataRunningCampaign.items.sortDesc = value) : (state.dataRunningCampaign.items.sortDesc = false)),
    SET_RUNNING_SEARCH: (state, value) => (value ? (state.dataRunningCampaign.items.search = value) : (state.dataRunningCampaign.items.search = '')),

    SET_CHANNEL_SELECTED: (state, value) => (value ? (state.channelSelected = value) : (state.channelSelected = 1)),
    SET_METHOD_SELECTED: (state, value) => (value ? (state.methodSelected = value) : (state.methodSelected = 1)),
    // SET_ITEM_DATA: (state, value) => (value ? (state.dataAuction.items = value) : (state.dataAuction.items = [])),
    // SET_DATA_WON_ITEM: (state, value) => (value ? (state.dataWon.items = value) : (state.dataWon.items = [])),
    // SET_DATA_CLOSE_ITEM: (state, value) => (value ? (state.dataClose.items = value) : (state.dataClose.items = [])),
    // SET_AUCTION_CURRENT_PAGE: (state, value) => (value ? (state.dataAuction.items.current_page = value) : (state.dataAuction.items.current_page = 1)),
    // SET_AUCTION_SORT_BY: (state, value) => (value ? (state.dataAuction.items.sortBy = value) : (state.dataAuction.items.sortBy = '')),
    // SET_AUCTION_SORT_DESC: (state, value) => (value ? (state.dataAuction.items.sortDesc = value) : (state.dataAuction.items.sortDesc = false)),
    // SET_AUCTION_SEARCH: (state, value) => (value ? (state.dataAuction.items.search = value) : (state.dataAuction.items.search = '')),
  },
  actions: {
    getDataBidding: ({ commit, getters, rootState }) => {
      const headers = { Authorization: `Bearer ${rootState.auth.userData.data.accessToken}` }
      // commit('SET_ITEM_DATA_BID')
      return new Promise((resolve, reject) => {
        const queryParam = requestApi(`page=${getters.getBiddingCurrentPage}&channel_id=${getters.getChannel}&method_id=${getters.getMethod}`)
        // console.log(`channel_id=${getters.getChannel}&method_id=${getters.getMethod}`)
        axiosIns.get(`/rtb/trafficPerformance?req=${queryParam.req}`, { headers })
          .then(response => {
            const newData = response.data
            commit('SET_ITEM_DATA_BID', newData)
            // console.log(newData)
            resolve(response.data)
          }).catch(error => {
            reject(error)
          })
      })
    },
    getRunningCampaign: ({ commit, getters, rootState }) => {
      const headers = { Authorization: `Bearer ${rootState.auth.userData.data.accessToken}` }
      return new Promise((resolve, reject) => {
        const queryParam = requestApi(`channel_id=${getters.getChannel}&method_id=${getters.getMethod}`)
        axiosIns.get(`/rtb/runningCampaign?req=${queryParam.req}`, { headers })
          .then(response => {
            const newData = response.data
            commit('SET_ITEM_DATA_RUN', newData)
            // console.log(newData)
            resolve(response.data)
          }).catch(error => {
            reject(error)
          })
      })
    },
    submitBidding({ getters, rootState }) {
      const headers = {
        Authorization: `Bearer ${rootState.auth.userData.data.accessToken}`,
      }
      return new Promise((resolve, reject) => {
        axiosIns.post('/rtb/submitBid', getters.getDataSend, { headers })
          .then(response => {
            // commit('SET_BUDGET_USAGE', response.data)
            resolve(response.data)
          }).catch(error => {
            reject(error)
          })
      })
    },
  //   getDataAuction: ({ commit }) => {
  //     const dataAuction = {
  //       total: 6,
  //       per_page: 6,
  //       current_page: 1,
  //       from: 1,
  //       to: 6,
  //       data: [
  //         {
  //           id: 1, channel: 'USSD', volume: '10000000', comments: 'CPA starting price: IDR 4000/CPA', day: 'Mon, Fri, Sat', hour: '07.00AM, 08.00AM', finish_time: '02/11/2021   17:00:00', winning_bid: '-', status: '1',
  //         },
  //         {
  //           id: 2, channel: 'SMS', volume: '10000000', comments: 'CPA starting price: IDR 4000/CPA', day: 'Mon, Fri, Sat', hour: '07.00AM, 08.00AM', finish_time: '02/11/2021   17:00:00', winning_bid: '-', status: '1',
  //         },
  //         {
  //           id: 3, channel: 'In App Notificatipn', volume: '10000000', comments: 'CPA starting price: IDR 4000/CPA', day: 'Mon, Fri, Sat', hour: '07.00AM, 08.00AM', finish_time: '02/11/2021   17:00:00', winning_bid: '-', status: '1',
  //         },
  //         {
  //           id: 4, channel: 'Flash Message', volume: '10000000', comments: 'CPA starting price: IDR 4000/CPA', day: 'Mon, Fri, Sat', hour: '07.00AM, 08.00AM', finish_time: '02/11/2021   17:00:00', winning_bid: '4915', status: '2',
  //         },
  //         {
  //           id: 5, channel: 'Digital Screen', volume: '10000000', comments: 'CPA starting price: IDR 4000/CPA', day: 'Mon, Fri, Sat', hour: '07.00AM, 08.00AM', finish_time: '02/11/2021   17:00:00', winning_bid: '5002', status: '3',
  //         },
  //         {
  //           id: 6, channel: 'USSD', volume: '10000000', comments: 'CPA starting price: IDR 4000/CPA', day: 'Mon, Fri, Sat', hour: '07.00AM, 08.00AM', finish_time: '02/11/2021   17:00:00', winning_bid: '4050', status: '3',
  //         },
  //       ],
  //     }
  //     commit('SET_ITEM_DATA', dataAuction)
  //   },
  //   getDataWon: ({ commit }) => {
  //     const dataWon = {
  //       total: 6,
  //       per_page: 6,
  //       current_page: 1,
  //       from: 1,
  //       to: 6,
  //       data: [
  //         {
  //           id: 4, channel: 'Flash Message', volume: '10000000', comments: 'CPA starting price: IDR 4000/CPA', day: 'Mon, Fri, Sat', hour: '07.00AM, 08.00AM', finish_time: '02/11/2021   17:00:00', winning_bid: '4915', status: '2',
  //         },
  //       ],
  //     }
  //     commit('SET_DATA_WON_ITEM', dataWon)
  //   },
  //   getDataClose: ({ commit }) => {
  //     const dataClose = {
  //       total: 6,
  //       per_page: 6,
  //       current_page: 1,
  //       from: 1,
  //       to: 6,
  //       data: [
  //         {
  //           id: 1, channel: 'USSD', volume: '10000000', comments: 'CPA starting price: IDR 4000/CPA', day: 'Mon, Fri, Sat', hour: '07.00AM, 08.00AM', finish_time: '02/11/2021   17:00:00', winning_bid: '5002', status: '3',
  //         },
  //         {
  //           id: 2, channel: 'SMS', volume: '10000000', comments: 'CPA starting price: IDR 4000/CPA', day: 'Mon, Fri, Sat', hour: '07.00AM, 08.00AM', finish_time: '02/11/2021   17:00:00', winning_bid: '4509', status: '3',
  //         },
  //         {
  //           id: 3, channel: 'In App Notificatipn', volume: '10000000', comments: 'CPA starting price: IDR 4000/CPA', day: 'Mon, Fri, Sat', hour: '07.00AM, 08.00AM', finish_time: '02/11/2021   17:00:00', winning_bid: '6340', status: '3',
  //         },
  //         {
  //           id: 4, channel: 'Flash Message', volume: '10000000', comments: 'CPA starting price: IDR 4000/CPA', day: 'Mon, Fri, Sat', hour: '07.00AM, 08.00AM', finish_time: '02/11/2021   17:00:00', winning_bid: '4915', status: '3',
  //         },
  //         {
  //           id: 5, channel: 'Digital Screen', volume: '10000000', comments: 'CPA starting price: IDR 4000/CPA', day: 'Mon, Fri, Sat', hour: '07.00AM, 08.00AM', finish_time: '02/11/2021   17:00:00', winning_bid: '5002', status: '3',
  //         },
  //         {
  //           id: 6, channel: 'USSD', volume: '10000000', comments: 'CPA starting price: IDR 4000/CPA', day: 'Mon, Fri, Sat', hour: '07.00AM, 08.00AM', finish_time: '02/11/2021   17:00:00', winning_bid: '4050', status: '3',
  //         },
  //       ],
  //     }
  //     commit('SET_DATA_CLOSE_ITEM', dataClose)
  //   },
  //   getAuction({ commit, getters }, payload) {
  //     const search = typeof payload.search !== 'undefined' ? payload.search : ''
  //     const status = typeof payload.status !== 'undefined' ? payload.status : ''
  //     const sortBy = typeof payload.sortBy !== 'undefined' ? payload.sortBy : ''
  //     const sortDirection = typeof payload.sortDirection !== 'undefined' ? payload.sortDirection : ''

  //     return new Promise((resolve, reject) => {
  //       // MENGGUNAKAN AXIOS PADA URL /ACCOUNT
  //       this.apiAccess.get(`/product?page=${getters.getAuctionItem.current_page}&filter=${search}&sortby=${sortBy}&sortdir=${sortDirection}&status=${status}`)
  //         .then(response => {
  //           // APABILA MENDAPATKAN RESPONSE, DATA AKAN DICOMMIT KE MUTATION SET_DATA_AUCTION_ITEM
  //           commit('SET_ITEM_DATA', response.data)
  //           resolve(response.data)
  //         }).catch(error => {
  //           reject(error)
  //         })
  //     })
  //   },
  //   async setAuction({ commit, rootState }, payload) {
  //     try {
  //       // return new Promise((resolve, reject) => async () => {
  //       const status = typeof payload.status !== 'undefined' ? payload.status : ''
  //       const headers = { Authorization: `Bearer ${rootState.auth.userData}` }
  //       const { response } = await this.apiAccess.post('gameDetail', status, { headers })
  //       commit('SET_COMPANY_STATUS', response.data)
  //       // resolve(response.data)
  //       // })
  //     } catch (error) {
  //       //
  //     }
  //   },
  },
}
